module.exports = __webpack_public_path__ + "images/10302bc9729e33c0a412775dd3b2adba-SLIC7959a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/home/SLIC7959a.jpg
// module id = ./src/assets/images/slides/home/SLIC7959a.jpg
// module chunks = 0